export default {
	cihangban: '此航班',
	paifangliang: '排放量是为您选择的座位级别中的1名乘客计算的',
	chengke: '乘客',
	quebaoziliaozhengque: '请确保所有资料正确',
	ruhetianxiechengke: '如何填写旅客资料',
	beizhu: '备注',
	chakanpiaojiaguize: '查看票价规则',
	shengyushijian: '尚余 X 分钟完成预订',
	zongjie: '费用',
	shuifeifujia: '税款及附加费',
	zonge: '总额',
	xingbie: '性别',
	nan: '男',
	nv: '女',
	xingshi: '姓氏',
	zhongjianming: '中间名',
	mingzi: '名字',
	lizi0: '例子:李',
	ruyou: '如有',
	lizi: '例子:SIU MENG',
	zhengjianleixing: '证件类型',
	qingxuanze: '请选择',
	huzhaohaoma: '护照号码',
	huzhao: '护照',
	piaohao: '票号',
	qingshuru: '请输入',
	queren: '确认',
	chongzhi: '重置',
	quxiao: '取消',
	baocun: '保存',
	huzhaoguojia: '护照国家地区',
	daoqiriqi: '护照有效期',
	chushengriqi: '出生日期',
	shifouchangke: '是否飞行常客会员？',
	lianluoren: '联络人资料',
	dianyoudizhi: '电邮地址',
	zhengquedianyoudizhi: '正确的电邮地址',
	lianluodianhua: '联络电话',
	qingshurudianhua: '电话号码',
	guojia: '国家',
	wanchengyuding: '完成你的预订',
	wancheng: '完成',
	fukuanxijie: '付款细节',
	shuikuanfujiafei: '含税款及附加费',
	woyiyueduotiaokuan: '本人已经细阅及同意条款与细则',
	woyiyueduo: '本人已经细阅及同意',
	baocunxiangxixinxi: '在此处保存详细信息以自动填写表格，以便日后预订航班。',
	xiayibu: '下一步',
	fanhui: '返回',
	xuanzezuowei: '请选择座位',
	ewaituibu: '额外腿部空间',
	shouxuan: '首选',
	biaozhun: '标准',
	yixuan: '已选',
	shangwu: '商务',
	jingji: '经济',
	meiyouxuanwei: '没有选位',
	xuanzezhong: '选择中',
	xiagehangban: '下个航班',
	chuangjiandingdan: '创建订单',
	chengkeanzhengjian:
		'所有头衔和乘客姓名必须完全按照护照或其他有效旅行证件上的显示输入。交易成功完成后，不允许修改所有权或乘客姓名。',
	shurudianziyoujian: '请输入接收确认的电子邮件地址。',
	hangbanbiangengshouyueshu: '航班变更受选定航空公司条款和条件的约束。',
	yudingzhongguanli:
		'您仍然可以在“我的预订”中更改*并管理您的航班预订。然而，请注意，对已确认预订的任何修改都将收取更改费，超过新购买的费用',
	cuxiaopiaojiabu: '促销票价可能不允许更改。',
	chakanlvxingjianyi: '请查看您旅行行程中的旅行建议和运输条款和条件，了解允许的更改。'
};
